module.exports = "<div class=\"insertelementhere\"  [attr.data-cellindex] = \"cellindex\" [attr.data-rowindex] = \"rowindex\">\n  Insert Element Here\n</div>\n"